import { _pHttp } from "../_pHttp";

export async function searchUser({ nationalCode, matchId }: any) {
  const { data } = await _pHttp.get(`users/${nationalCode}/tickets/${matchId}`);
  return data;
}

export const getProvinceReported = async ({ matchId }: any) => {
  const { data } = await _pHttp.get(`attendees/report/details-list-province/${matchId}`);
  return data;
};

export const getCityReported = async ({ matchId }: any) => {
  const { data } = await _pHttp.get(`attendees/report/details-list-city/${matchId}`);
  return data;
};
export const getCityReportedExcel = async ({ matchId }: any) => {
  try {
    const response = await _pHttp.get(
      `attendees/report/details-list-city/excel/${matchId}`,
      {
        responseType: "arraybuffer",
      }
    );
    const contentType =
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([response.data], { type: contentType });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `fan-cards-report.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export const getProvinceReportedExcel = async ({ matchId }: any) => {
  try {
    const response = await _pHttp.get(
      `attendees/report/details-list-province/excel/${matchId}`,
      {
        responseType: "arraybuffer",
      }
    );
    const contentType =
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob = new Blob([response.data], { type: contentType });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");

    a.href = url;
    a.download = `province-report.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};